// router/index.ts
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

// Layouts
import DefaultLayout from '@/interfaces/layouts/default.vue';
import DocumentLayout from '@/interfaces/layouts/document.vue';

// Routes
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/interfaces/pages/index.vue'),
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/interfaces/pages/index.vue'), // adjust if different
      },
    ],
  },
  {
    path: '/documents',
    component: DocumentLayout,
    children: [
      {
        path: ':id',
        name: 'DocumentViewer',
        component: () => import('@/interfaces/pages/documents/[id].vue'),
      },
      {
        path: ':documentId/passages/:passageKey',
        name: 'PassageExplorer',
        component: () =>
          import('@/interfaces/pages/documents/[passageKey].vue'),
      },
    ],
  },
  {
    path: '/chat/:id/export',
    name: 'ChatExport',
    component: () => import('@/interfaces/pages/chat_export/[id].vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/interfaces/pages/reset-password/index.vue'),
  },
  {
    path: '/after-auth-google',
    name: 'after-auth-google',
    component: () => import('@/interfaces/pages/after-auth-google/index.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
